<template>
  <section class="state">
    <img class="state__img" :src="img" />
    <h1 class="state__heading">{{ $t(heading) }}</h1>
    <html-with-links
      v-if="message"
      tag="span"
      class="state__status g-status"
      :class="{
        'g-status_error': state === 'error',
        'g-status_success': state === 'success',
      }"
      :html="$t(message)"
    ></html-with-links>
    <a class="g-button" @click.prevent="go">{{ $t(linkText) }}</a>
  </section>
</template>

<script>
import HtmlWithLinks from '@/components/HtmlWithLinks.vue';

export default {
  components: {
    HtmlWithLinks,
  },
  props: {
    state: {},
    heading: {},
    message: {},
    link: {},
    linkText: {
      default: 'GO BACK',
    },
  },
  computed: {
    img() {
      return this.state === 'success' ? require('@/assets/success.svg') : require('@/assets/error.svg');
    },
  },
  methods: {
    go() {
      if (!this.link) {
        this.$router.go(-1);
        return;
      }
      this.$router.push({ path: this.link });
    },
  },
};
</script>

<style lang="scss" scoped>
.state {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;

  &__img {
    max-width: 100%;
  }

  &__heading {
    font-size: 16px;
    font-weight: 500;
    margin: 15px 0 10px;
  }

  &__status {
    font-size: 14px;
    margin-bottom: 15px;
    white-space: pre-line;
  }
}
</style>
